import React, { useContext, Fragment } from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';
import { ShowContext } from '../../context/showContext'
import './Navbar.module.css'

export const Navbar = () => {

  const { id } = useParams();
  const { imageDescription, isShow } = useContext(ShowContext)

  return (
    <Fragment>
      <div className='navContainer'>
        <div className='brandContainer'><Link to="/">Joaquin Boz</Link></div>
        <div className='linksContainer'>
          <Link to="/information">info</Link>
          <Link to="/">cv</Link>
        </div>
      </div>
      {
        isShow &&
        <div className='descriptionContainer'>
          <div>{imageDescription.description}</div>
          <div>{imageDescription.dimensions}</div>
        </div>
      }
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/layout/navbar/Navbar.jsx